import { GetUserInfo } from 'domain/usecases/get-user-info';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetUserInfo extends BaseHttpService<GetUserInfo.Model> implements GetUserInfo {
  async get(params: GetUserInfo.Params): Promise<GetUserInfo.Model> {
    return await this.request('get', {}, params);
  }
}
